import {getChildById, getChildKeyById} from './utils/getChild'
import woothee from 'woothee';

// reducer
let Reducer;
const isPc = woothee.parse(window.navigator.userAgent).category === 'pc';
const body = document.getElementsByTagName('body')[0];

const defaultState = {
  date: null,
  formRef: null,
  selectedId: null,
  selectedDate: {
    month:'',
    date: '',
    type: ''
  },
  items: [],
  filteredItems: [],
};

const parseHash = hash=>{
  const ary = hash.split('/');
  let date = {
    month: '1',
    date:  '1'
  }
  console.log(ary);
  if(ary.length < 3)return date;
  if(parseInt(ary[1],10) > 12)return date;
  if(parseInt(ary[2],10) > 31)return date;

  date = {
    month: ary[1],
    date: ary[2],
  }

  if(ary.length > 3){
    date.type= ary[3].split(',');
  }
  return date;
}

const createParam = data=>{
  let param = {
    month: data.month,
    date: data.date,
    type: data.type,
  };

  if(data.year !== '1980'){
    param.special = data.year;
  }
  return param;
}

export default Reducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'FETCHING':
      return Object.assign({}, state, {
        isFetching: true
      });
    break;
    case 'LOADED':
      return Object.assign({}, state, {
        isFetching: false
      });
    break;
    case 'PUSH_ITEMS':
      return Object.assign({}, state, {
        items: action.payload
      });
    break;
    case 'PUSH_FILTERED_ITEMS':
      let items = state.items.filter((item,key,array)=>{
        if(typeof state.date.type === 'undefined' || state.date.type.indexOf('all') >= 0){
          return (item.month === state.date.month && item.date === state.date.date);
        }else{
          return (item.month === state.date.month && item.date === state.date.date && state.date.type.indexOf(item.type) >= 0);
        };
      });
      return Object.assign({}, state, {
        filteredItems: items
      });
    break;
    case 'PARSE_HASH':
      return Object.assign({}, state, {
        date: parseHash(location.hash)
      });
    break;
    case 'SET_DATE':
      const id = action.payload;
      return Object.assign({}, state, {
        selectedId: id,
        selectedDate: createParam(state.filteredItems[id])
      });
    break;
    case 'FORM_REF':
      return Object.assign({}, state, {
        formRef: action.payload
      });
    break;
    case 'SEND_DATA':
      state.formRef.submit();
      return Object.assign({}, state);
    break;
    default:
      return state;
    break;
  }
};



// WEBPACK FOOTER //
// ./source/javascripts/reducer.js